import React from 'react';
import type { DecoratedArchiveItem } from './types';
import { GRID_TEMPLATE } from './constants';

interface Props {
  item: DecoratedArchiveItem;
  onArchive: () => void;
  onDismiss: () => void;
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

function formatAmount(n: number): string {
  const abs = Math.abs(n);
  const formatted = abs.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return n < 0 ? `-$${formatted}` : `$${formatted}`;
}

export default function ArchiveRow({ item, onArchive, onDismiss }: Props): React.ReactElement {
  const isZero = item.balance === 0;
  return (
    <div
      className="grid gap-4 items-center px-5 py-3.5 border-b border-lineSoft text-small bg-white hover:bg-[#EEF4FB] transition-colors"
      style={{ gridTemplateColumns: GRID_TEMPLATE }}
    >
      <div>
        <div className="font-bold text-ink">{item.accountName}</div>
        <div className="text-helper text-small">{item.detailType}</div>
      </div>
      <div className="text-ink2">{item.accountType}</div>
      <div className="text-ink2">{formatDate(item.lastActivityDate)}</div>
      <div className="text-ink2">{item.transactionCount}</div>
      <div className={`text-right font-semibold tabular-nums ${isZero ? 'text-ink4 font-medium' : 'text-ink'}`}>
        {formatAmount(item.balance)}
      </div>
      <div className="flex gap-1.5 justify-end">
        <button
          type="button"
          onClick={onDismiss}
          className="h-8 px-3 border border-line bg-white text-ink2 text-small font-semibold rounded-md cursor-pointer"
        >
          Dismiss
        </button>
        <button
          type="button"
          onClick={onArchive}
          className="h-8 px-3.5 bg-ink text-white text-small font-bold rounded-md cursor-pointer border-none"
        >
          Archive
        </button>
      </div>
    </div>
  );
}